var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('router-view'):_c('div',{staticClass:"flex items-center justify-center h-full"},[_c('spinner-color-2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }